module.exports = __webpack_public_path__ + "static/media/fiddlehead.80fad0e0.jpg";